import { store } from "../../store/store";
import slugify from "slugify";

class ORMFunctions {
  i18n(word: string, fromall = false) {
    const translations = store.getState().general.translations;

    function flattenObject(obj: any, prefix = ""): Record<string, any> {
      return Object.keys(obj).reduce<Record<string, any>>((acc, key) => {
        const pre = prefix.length ? prefix + "/" + key : key;
        if (typeof obj[key] === "object" && obj[key] !== null) {
          Object.assign(acc, flattenObject(obj[key], pre));
        } else {
          acc[pre] = obj[key];
        }
        return acc;
      }, {});
    }
    const flattened = flattenObject(translations);

    if (!fromall) {
      word = "ORMLF/" + word;
    }

    if (flattened[word]) {
      return flattened[word];
    } else {
      return null;
    }
  }

  slugMe(string: string) {
    return slugify(string, {
      replacement: "-", // replace spaces with replacement character, defaults to `-`
      remove: /[*+~.()'"!:,@/]/g, // remove characters that match regex, defaults to `undefined`
      lower: true, // convert to lower case, defaults to `false`
      strict: false, // strip special characters except replacement, defaults to `false`
      locale: "de", // language code of the locale to use
    });
  }

  checkcookie(type: string): boolean {
    // Hilfsfunktion zum Parsen von Cookies
    const getCookie = (cname: string): any => {
      const name = cname + "=";
      const decodedCookie = decodeURIComponent(document.cookie);
      const ca = decodedCookie.split(";");

      for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();

        if (c.indexOf(name) === 0) {
          const cookieValue = c.substring(name.length);
          try {
            return JSON.parse(cookieValue);
          } catch {
            return cookieValue;
          }
        }
      }
      return null;
    };

    // Wenn Cookie Consent deaktiviert ist, immer true zurückgeben
    if (process.env.REACT_APP_COOKIECONSENT === "false") {
      return true;
    }

    // Array-basiertes Cookie Consent System
    if (process.env.REACT_APP_COOKIECONSENTARRAY === "true") {
      const cookieName = process.env.REACT_APP_COOKIECONSENTCOOKIENAME;
      if (!cookieName) return false;

      const cookie = getCookie(cookieName);
      // console.log("cookie", cookie, document.cookie);

      if (!cookie) return false;

      // Prüfe options Array
      if (cookie.options && Array.isArray(cookie.options)) {
        return cookie.options.includes(type);
      }

      // Prüfe checkboxes Array
      if (cookie.checkboxes && Array.isArray(cookie.checkboxes)) {
        const checkbox = cookie.checkboxes.find((cb: any) => cb.name === type);
        return checkbox ? checkbox.checked === true : false;
      }

      return false;
    }

    // Einfaches Cookie System (direkter Cookie-Name)
    const cookieValue = getCookie(type);
    return (
      cookieValue === true ||
      cookieValue === 1 ||
      cookieValue === "1" ||
      cookieValue === "true"
    );
  }
}

const ORMfunctions = new ORMFunctions();
export default ORMfunctions;
